import { StrikeZone } from "../types/StrikeZone";

export const PITCH_RESET_TIMEOUT = 10000;
export const DEFAULT_STRIKE_ZONE: StrikeZone = {
  szTop: 6.0 * 0.54,
  szBottom: 6.0 * 0.27,
  szWidth: 17.0,
};
